export const TENCENT_CAPTCHA_ERROR_CODE = {
    USER_CLOSE: 'user_close',
};
